import { Space, CreateSpaceDto, UpdateSpaceDto } from '@risk-management/shared';
import { apiService } from './api.service';

export const spacesService = {
  /**
   * Get all public spaces
   */
  getPublic: () => apiService.get<Space[]>('/spaces'),

  /**
   * Get all spaces accessible to the current user
   * (public + user direct access + team access)
   */
  getAccessible: () => apiService.get<Space[]>('/spaces/accessible'),

  /**
   * Get space by ID
   */
  getById: (id: string) => apiService.get<Space>(`/spaces/${id}`),

  /**
   * Create a new space
   */
  create: (data: CreateSpaceDto) => apiService.post<Space>('/spaces', data),

  /**
   * Update a space
   */
  update: (id: string, data: UpdateSpaceDto) =>
    apiService.patch<Space>(`/spaces/${id}`, data),

  /**
   * Delete a space
   */
  delete: (id: string) => apiService.delete<void>(`/spaces/${id}`),

  /**
   * Get access permissions for a space
   */
  getAccess: (spaceId: string) =>
    apiService.get<{
      teams: Array<{
        id: string;
        teamId: string;
        permissionLevel: string;
        team: { id: string; name: string };
      }>;
      users: Array<{
        id: string;
        userId: string;
        permissionLevel: string;
        user: { id: string; email: string; name: string };
      }>;
    }>(`/spaces/${spaceId}/access`),

  /**
   * Grant team access to a space
   */
  grantTeamAccess: (spaceId: string, teamId: string, permissionLevel: string) =>
    apiService.post(`/spaces/${spaceId}/access/team`, {
      teamId,
      permissionLevel,
    }),

  /**
   * Grant user access to a space
   */
  grantUserAccess: (spaceId: string, userId: string, permissionLevel: string) =>
    apiService.post(`/spaces/${spaceId}/access/user`, {
      userId,
      permissionLevel,
    }),

  /**
   * Update team access permission level
   */
  updateTeamAccess: (
    spaceId: string,
    teamId: string,
    permissionLevel: string
  ) =>
    apiService.patch(`/spaces/${spaceId}/access/team/${teamId}`, {
      permissionLevel,
    }),

  /**
   * Update user access permission level
   */
  updateUserAccess: (
    spaceId: string,
    userId: string,
    permissionLevel: string
  ) =>
    apiService.patch(`/spaces/${spaceId}/access/user/${userId}`, {
      permissionLevel,
    }),

  /**
   * Revoke team access
   */
  revokeTeamAccess: (spaceId: string, teamId: string) =>
    apiService.delete<void>(`/spaces/${spaceId}/access/team/${teamId}`),

  /**
   * Revoke user access
   */
  revokeUserAccess: (spaceId: string, userId: string) =>
    apiService.delete<void>(`/spaces/${spaceId}/access/user/${userId}`),
};
